module.exports = __webpack_public_path__ + "images/sample.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/sample.jpg
// module id = 6
// module chunks = 0